import { render, staticRenderFns } from "./bindList.vue?vue&type=template&id=003c189c&scoped=true"
import script from "./bindList.vue?vue&type=script&lang=js"
export * from "./bindList.vue?vue&type=script&lang=js"
import style0 from "./bindList.vue?vue&type=style&index=0&id=003c189c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c189c",
  null
  
)

export default component.exports